import { render, staticRenderFns } from "./CryptomatsTransactions.vue?vue&type=template&id=a53acaba&scoped=true&"
import script from "./CryptomatsTransactions.vue?vue&type=script&lang=js&"
export * from "./CryptomatsTransactions.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsTransactions.vue?vue&type=style&index=0&id=a53acaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53acaba",
  null
  
)

export default component.exports